$ = require 'jquery'
_ = require 'underscore'
AddMemberToTeamView = require 'views/member/add-to-team-popover-view'
Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
f = require 'effing'
l = require 'lib/localize'
Controller = require 'controller'
BulkAddOrgMembersView = require 'views/organization/bulk-add-org-members-view-react'
ManageOrgMembersComponent = require 'views/organization/manage-org-members-component'
Member = require 'models/member'
{ maybeDisplayOrgMemberLimitsError } = require 'views/organization/member-limits-error'
MemberOrgActivityView = require 'views/organization/member-org-activity-view'
OrganizationChangeRolePopoverView = require 'views/member/organization-change-role-popover-view'
OrganizationLinkGAHelperView = require 'views/organization/organization-link-ga-helper-view'
OrganizationMembersComponent = require 'views/organization/organization-members-component'
OrganizationView = require 'views/organization/organization-view'
Promise = require 'bluebird'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
RemoveOrDeactivateOrgMemberView = require 'views/organization/remove-or-deactivate-org-member-view'
t = require('views/internal/recup-with-helpers')('org_members')
track = require 'debug/track'
localizeCount = require 'lib/localize-count'

module.exports = class OrganizationMembersView extends OrganizationView

  initialize: ->
    super

    @getGoogleAppsData()

    @listenTo @model,
      'change:idBoards': @renderReactSection

    @listenTo @model,
      'change:memberships': @renderReactSection

    @listenTo @model,
      'change:memberships': @getCollaborators

    @listenTo @model,
      'change:collaborators': @renderReactSection

    @listenTo @model,
      'change:bulkAddMemberErrors': @renderReactSection

    @listenTo Auth.me(),
      'change:messagesDismissed', @frameDebounce @renderReactSection

    for board in @model.boardList.models
      @listenTo board.memberList, 'add remove reset', @renderReactSection

    return

  isFullWidth: -> true

  renderMainContent: ->
    @reactRoot ?= document.createElement('div')
    @$('.js-content').append(@reactRoot)
    @renderReactSection()
    @setActiveView('.js-org-members')

    @

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @reactRoot)

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @getOrgMembersComponent()

  getOrgMembersComponent: ->
    collaboratorProps = @getCollaboratorProps()
    enterpriseProps = @getEnterpriseProps()
    orgProps = @getOrgProps()

    props =
      # enterprise props
      isEnterpriseAdmin: enterpriseProps.isEnterpriseAdmin
      # org props
      orgName: orgProps.orgName
      orgIsEmpty: orgProps.orgIsEmpty
      orgMemberModels: orgProps.orgMemberModels
      orgId: orgProps.orgId
      orgIsPO: orgProps.orgIsPO
      orgIsBC: orgProps.orgIsBC
      # guest props
      collaboratorModels: collaboratorProps.collaboratorModels
      sidebar: @orgToOrgSidebarProps()

    React.createElement OrganizationMembersComponent, props

  orgToOrgSidebarProps: ->
    me = Auth.me()
    isAdDismissed = me.isAdDismissed('security-features')

    props =
      canManageMembers: @model.editable()
      canLinkGoogleApps: @model.isFeatureEnabled('googleApps') && (!@model.get('prefs').associatedDomain || @googleAppsFetchFailed) && @model.editable()
      canShowAll: @model.isFeatureEnabled('googleApps') && _.any @mappingsData, (user) => @modelCache.findOne('Member', 'gMail', user.gMail)?.get('hidden') || user.hidden
      onLinkGoogleApps: @startLinkingGoogleApps.bind(@)
      openManageMembers: @openManageMembers.bind(@)
      openBulkAdd: @openBulkAdd.bind(@)
      billingUrl: Controller.getOrganizationBillingUrl(@model)
      hasBC: @model.isPremium()
      ownsOrg: @model.owned()
      isAdDismissed: isAdDismissed
      dismissAd: me.dismissAd.bind(me, 'security-features')
      inviteTeamMembers: @inviteTeamMembers.bind(@) || null
      model: @model
      bulkAddMemberErrors: @model.getBulkAddMemberErrors()

    props

  getGoogleAppsData: ->
    if !@model.isLinkedToGoogleApps() || !@model.editable()
      return

    @model.getGoogleAppsMappings()
    .then (data) =>
      @mappingsData = data
    .catch (err) =>
      @googleAppsFetchFailed = true
    .finally =>
      @renderMainContent()
    .done()

  startLinkingGoogleApps: (el) ->
    track("Organization View", "Members Page", "Start Linking Google Apps Domain")

    PopOver.toggle
      elem: el
      view: OrganizationLinkGAHelperView
      options: { @model, @modelCache }

  openManageMembers: (el) ->
    track("Organization View", "Members Page", "Open Manage Members")

    PopOver.toggle
      elem: el
      getViewTitle: -> l ['view title', 'members']
      reactElement: React.createElement ManageOrgMembersComponent, {
        key: 'members'
        @model
        @modelCache
      }

    return

  inviteTeamMembers: (el) ->
    track("Organization View", "Members Page", "Invite Team Members")

    PopOver.toggle
      elem: el
      getViewTitle: -> l ['view title', 'add members']
      reactElement: React.createElement ManageOrgMembersComponent, {
        key: 'members'
        @model
        @modelCache
      }

    return

  openBulkAdd: (el) ->
    track("Organization View", "Members Page", "Open Bulk Add")

    if maybeDisplayOrgMemberLimitsError(el, @model, null)
      return

    PopOver.toggle
      elem: el
      getViewTitle: -> l ['view title', 'add members']
      reactElement: React.createElement BulkAddOrgMembersView, {
        key: 'bulk add members'
        @model
      }

    return

  memberToModelForMemberItemElement: (member, boardCount) ->
    memberType = @model.getMemberType(member)

    props =
      isVirtual: memberType == 'virtual'
      isDeactivated: memberType == 'deactivated'
      fullName: member.get('fullName')
      username: member.get('username')
      showGoogleApps: @model.isLinkedToGoogleApps() && @model.editable() && @mappingsData?
      gMail: member.get('gMail')
      boardCount: boardCount
      isOrgMember: memberType != 'public'
      showActivity: @model.owned() && memberType != 'virtual'
      allowTypeChange: @model.owned() && memberType !in ['deactivated', 'unconfirmed', 'virtual']
      orgMemberType: l(['member types', memberType])
      allowReactivate: @model.owned() && memberType == 'deactivated'
      isMe: Auth.isMe(member)
      canRemove: member.getMembershipData(@model).canRemove
      orgIsBC: @model.isPremium()
      ownsOrg: @model.owned()
      hidden: member.get('hidden')
      onViewActivity: @viewMemberActivity.bind(@, member)
      onRoleChange: @changeRole.bind(@, member)
      onRemoveOrDeactivate: @removeOrDeactivate.bind(@, member)
      avatarHash: member.get('avatarHash')
      avatarDomain: window.avatarDomain
      initials: member.get('initials')
      isOrganizationAdmin: memberType == 'admin'
      onReactivateClick: @reactivateMember.bind(@, member)
      onUnhideMember: @unhideMember.bind(@, member)
      onHideMember: @hideMember.bind(@, member)
      onInviteMember: @inviteToOrg.bind(@, member)
      onAddToTeam: @addToTeam.bind(@, member)

    props

  getCollaborators: ->
    @model.fetchCollaborators()
    # add error state messaging here for failing to update guest information
    .catch (e) => null
    .finally => @renderReactSection()

  isCurrentEnterpriseAdmin: ->
    _.some(Auth.me().get('idEnterprisesAdmin'), (id) => id == @model.getEnterprise()?.get('id'))

  getEnterpriseProps: ->
    enterpriseProps =
      isEnterpriseAdmin: @isCurrentEnterpriseAdmin()

    enterpriseProps

  getBoardCount: (member) ->
    boardCount = 0
    for board in _.filter(@model.boardList.models, (board) => board.isOpen())
      if member in board.memberList.models
        boardCount++
    boardCount

  getOrgProps: ->
    orgMemberModels = @getMembers().map (member) =>
      @memberToModelForMemberItemElement(member, @getBoardCount(member))

    orgProps =
      orgId: @model.id
      orgName: @model.get('displayName')
      orgIsEmpty: orgMemberModels.length == 1 &&
        _.some(orgMemberModels, (member) => member.isMe && member.isOrganizationAdmin)
      orgMemberModels: orgMemberModels
      orgIsPO: @model.paysWithPurchaseOrder()
      orgIsBC: @model.isBusinessClass()

    orgProps

  getOrgCollaboratorModels: (arr, member) ->
    teamMemberIds = _.pluck(@getMembers(), 'id')
    if member.id in teamMemberIds then return arr

    boardCount = @getBoardCount(member)
    if boardCount < 1 then return arr

    arr.push(@memberToModelForMemberItemElement(member, boardCount))
    arr

  getCollaboratorProps: ->
    orgCollaboratorModels = _.chain @model.collaboratorList.models
      .reduce ((arr, member) => @getOrgCollaboratorModels(arr, member)), []
      .value()

    collaboratorProps =
      collaboratorModels: orgCollaboratorModels

    collaboratorProps

  getMembers: ->
    members = _.clone @model.memberList.models

    if @mappingsData?
      for user in @mappingsData
        if user.idMember?
          member = @modelCache.get('Member', user.idMember)
          if !member?
            member = new Member({ id: user.idMember, fullName: user.fullName, gMail: user.gMail, initials: user.initials, hidden: user.hidden }, { @modelCache })
          else
            member.set('gMail', user.gMail)
        else
          member = @modelCache.findOne('Member', 'gMail', user.gMail)
          if !member?
            member = new Member({ fullName: user.fullName, gMail: user.gMail, initials: user.initials, hidden: user.hidden }, { @modelCache })
            # Make it quicker to find this member on the next getMember call
            user.idMember = member.cid
        if member !in members
          members.push member

    deactivated = []
    for mem in members
      if @model.getMemberType(mem) == 'deactivated' # only way to deactivated, i guess
        deactivated.push mem

    ghosts = []
    for mem in members
      if @model.getMemberType(mem) == 'virtual'
        ghosts.push mem

    allOtherMems = _.difference(members, ghosts, deactivated)

    return allOtherMems.concat(deactivated).concat(ghosts)

  inviteToOrg: (member) ->
    track("Organization View", "Members Page", "Add Google Apps Member")
    Promise.try =>
      if member.id
        @model.changeMemberRole(member, { type: 'normal' })
      else
        @model.addMemberRole
          fullName: member.get('fullName')
          email: member.get('gMail')
          type: 'normal'
        .then ->
          Alerts.show('invitation sent', 'info', 'alert', 3000)
    .catch ApiError, (err) ->
      Alerts.showLiteralText(err.localizedMessage(), 'error', 'alert', 3000)
      track("Invitations", "Error: #{err.message}")
      return
    .done()

  addToTeam: (member, el) ->
    track("Organization View", "Members Page", "Add Guest to Team")

    org = @model

    isBC = org.isBusinessClass()

    if isBC
      PopOver.toggle
        elem: el
        view: new AddMemberToTeamView({
          isBC
          model: member
          org,
          showAlert: true,
          isOrgView: true
        })
    else

      if maybeDisplayOrgMemberLimitsError(el, org, member)
        return

      org.addMembers(member)
      .then (statusMessages) =>
        successResponse = statusMessages[statusMessages._categories.ADDED]

        if successResponse?
          Alerts.show('added to team', 'confirm', 'info', 3000)

        PopOver.hide()

  hideMember: (member) ->
    if !member.get('gMail')
      return
    member.set('hidden', true)

    @model.toggleMemberHidden(member, { type: 'post' })
    @renderReactSection()

  unhideMember: (member) ->
    if !member.get('gMail')
      return
    member.set('hidden', false)

    @model.toggleMemberHidden(member, { type: 'delete' })
    @renderReactSection()

  reactivateMember: (member, el) ->
    track("Organization View", "Members Page", "Reactivate")

    @model.reactivateMember(member)
    .catch ApiError, (err) ->
      Alerts.showLiteralText(err.localizedMessage(), 'error', 'alert', 3000)
      track("Invitations", "Error: #{err.message}")
      return
    .done()

  removeOrDeactivate: (member, el) ->
    track("Organization View", "Members Page", "Remove or Deactivate Member Button")

    PopOver.toggle
      elem: el
      view: RemoveOrDeactivateOrgMemberView
      options: {
        model: member,
        org: @model,
        @modelCache,
        onRemoveSuccess: =>
          if !Auth.isMe(member)
            Alerts.show('removed from team', 'warning', 'info', 3000)
      }

    return

  viewMemberActivity: (member, el) ->
    track("Organization View", "Members Page", "View Member Activity")

    PopOver.toggle
      elem: el
      view: MemberOrgActivityView
      options: { model: member, org: @model, @modelCache }

    return

  changeRole: (member, el) ->
    track("Organization View", "Members Page", "Change Role Button")

    PopOver.toggle
      elem: el
      view: OrganizationChangeRolePopoverView
      options: { model: member, parent: @model, @modelCache }

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-view.coffee